export default {
    METRIC_TYPE: {
        FundraisingPageRaised: "frpraised",
        Raised: "raised",
        EventCampaignBeneficiaryRaised: "ecbraised",
        TotalSleep: "totalsleep"
    },
    PAGE_TYPE: {
        Individual: "S",
        Team: "T"
    }
}
